import { isGatewayOrHybrid } from '@pagarme/enums'

export const SETTINGS_FUNCIONALITIES_CONFIG_ACTIONS_ENUM = {
  viewManualFlow: 'settings.manual_flow:view'
}

const isSettingsManualFlowViewEnabled = ({
  permissionIsEnabledFn,
  isEmployee,
  businessModel,
  hasPublicMerchantKey
}) => {
  const hasPermissionOrIsEmployee =
    permissionIsEnabledFn(
      SETTINGS_FUNCIONALITIES_CONFIG_ACTIONS_ENUM.viewManualFlow
    ) || isEmployee

  return (
    hasPermissionOrIsEmployee &&
    isGatewayOrHybrid(businessModel) &&
    hasPublicMerchantKey
  )
}
export { isSettingsManualFlowViewEnabled }
